/**
 * One status → badge-class mapping for every page (2026-09-02). The hues for
 * Pending (#FF5A60) and Cancelled/Rescheduled (#a40000) are Scheduling's own,
 * so a status reads identically on the calendar, a booking page, and a
 * property's booking list.
 */
export const statusBadgeClass = (status) => {
    const s = String(status || '').toLowerCase();
    if (s.includes('cancel') || s.includes('reschedul') || s.includes('deleted')) return 'dp-status dp-status--cancelled';
    if (s.includes('pending')) return 'dp-status dp-status--pending';
    if (s.includes('progress') || s.includes('process')) return 'dp-status dp-status--inprocess';
    if (s.includes('complet')) return 'dp-status dp-status--completed';
    if (s.includes('confirm')) return 'dp-status dp-status--confirmed';
    return 'dp-status';
};
